export default __webpack_public_path__ + "static/media/Comp_11.ae2704f0.gif";